/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiClientEligibility,
  ApiClientEligibilityFromJSON,
  ApiClientEligibilityFromJSONTyped,
  ApiClientEligibilityToJSON,
} from './ApiClientEligibility';
import {
  ApiExperimentEligibility,
  ApiExperimentEligibilityFromJSON,
  ApiExperimentEligibilityFromJSONTyped,
  ApiExperimentEligibilityToJSON,
} from './ApiExperimentEligibility';
import {
  ApiPetEligibility,
  ApiPetEligibilityFromJSON,
  ApiPetEligibilityFromJSONTyped,
  ApiPetEligibilityToJSON,
} from './ApiPetEligibility';
import {
  ApiRxEligibility,
  ApiRxEligibilityFromJSON,
  ApiRxEligibilityFromJSONTyped,
  ApiRxEligibilityToJSON,
} from './ApiRxEligibility';
import {
  ApiUserEligibility,
  ApiUserEligibilityFromJSON,
  ApiUserEligibilityFromJSONTyped,
  ApiUserEligibilityToJSON,
} from './ApiUserEligibility';

/**
 * helps determining the criteria for eligibility of current micro interaction
 * @export
 * @interface ApiMicroInteractionEligibility
 */
export interface ApiMicroInteractionEligibility {
  /**
   *
   * @type {ApiUserEligibility}
   * @memberof ApiMicroInteractionEligibility
   */
  user?: ApiUserEligibility;
  /**
   *
   * @type {ApiPetEligibility}
   * @memberof ApiMicroInteractionEligibility
   */
  pet?: ApiPetEligibility;
  /**
   *
   * @type {ApiExperimentEligibility}
   * @memberof ApiMicroInteractionEligibility
   */
  experiment?: ApiExperimentEligibility;
  /**
   *
   * @type {ApiClientEligibility}
   * @memberof ApiMicroInteractionEligibility
   */
  client?: ApiClientEligibility;
  /**
   *
   * @type {ApiRxEligibility}
   * @memberof ApiMicroInteractionEligibility
   */
  rx?: ApiRxEligibility;
}

export function ApiMicroInteractionEligibilityFromJSON(json: any): ApiMicroInteractionEligibility {
  return ApiMicroInteractionEligibilityFromJSONTyped(json, false);
}

export function ApiMicroInteractionEligibilityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiMicroInteractionEligibility {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    user: !exists(json, 'user') ? undefined : ApiUserEligibilityFromJSON(json['user']),
    pet: !exists(json, 'pet') ? undefined : ApiPetEligibilityFromJSON(json['pet']),
    experiment: !exists(json, 'experiment')
      ? undefined
      : ApiExperimentEligibilityFromJSON(json['experiment']),
    client: !exists(json, 'client') ? undefined : ApiClientEligibilityFromJSON(json['client']),
    rx: !exists(json, 'rx') ? undefined : ApiRxEligibilityFromJSON(json['rx']),
  };
}

export function ApiMicroInteractionEligibilityToJSON(
  value?: ApiMicroInteractionEligibility | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    user: ApiUserEligibilityToJSON(value.user),
    pet: ApiPetEligibilityToJSON(value.pet),
    experiment: ApiExperimentEligibilityToJSON(value.experiment),
    client: ApiClientEligibilityToJSON(value.client),
    rx: ApiRxEligibilityToJSON(value.rx),
  };
}
